import React from 'react';
import Head from 'next/head';
import PropTypes from 'prop-types';

import client from '@/apollo-client';
import Container from '@/components/Container/Container';
import Header from '@/components/Header/Header';
import IssueList from '@/components/IssueList/IssueList';
import { getIssues } from '@/graphql/queries';

export default function Issue({ issues }) {
  return (
    <>
      <Head>
        <title>Issues | cake-mag.com</title>
      </Head>
      <Header />
      <Container>
        <section className="section">
          <h1>Cake Issues</h1>
          <IssueList list={issues} />
        </section>
      </Container>
    </>
  );
}

export async function getStaticProps() {
  const { query } = getIssues();
  const { data } = await client.query({ query });
  const issues = data?.categories?.nodes;

  return {
    props: {
      issues,
    },
    revalidate: 12 * 60 * 60, // 12 hours
  };
}

Issue.propTypes = {
  issues: PropTypes.array,
};
